import React, { useState, useEffect } from "react"
import Web3 from "web3"
import Cookies from "universal-cookie"
import swal from "sweetalert"
import "../styles/table.css"
import Footer from "../components/footer"
import { createGlobalStyle } from "styled-components"
import Menu from "./menu"
import { Form, Input, Select, Button } from "antd"
import { BaseUrl } from "../utils/config"
import { useNavigate } from "@reach/router"
import {
  BrowserRouter as Router,
  Link,
  useHistory,
  useLocation
} from "react-router-dom"
import axios from "axios"
import ModalMint from "../components/ModalMint"
import Dropdown from "../components/dropdown"
import constant from "../../constants/constants"
import { useSelector, useDispatch } from "react-redux"
import { capitalize } from "../../utils"
import {
  setConnectedWallet,
  updateUserDetailsRedux,
  setActiveMenu
} from "../../redux/actions"
// Style
import "../../assets/css/marketplace.css"
import "../../assets/css/productDetail.css"

// Image
import nftimage from "./images/rednft.png"
import { useLogout } from "../../hooks"

const cookies = new Cookies()

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`

const ProductDetails = props => {
  const [singleProduct, setSingleProduct] = useState(null)
  const [isUserLogin, setIsUserLogin] = useState(false)
  const [userLogin, setUserLogin] = useState(null)
  const [openLogin, setOpenLogin] = useState(true)
  const [viewModal, setViewModal] = useState(false)

  const dispatch = useDispatch()
  const logoutHandler = useLogout()

  const modalDropdown = [
    { value: "", label: "Select Token" },
    { value: "2", label: "2" }
  ]
  const userData = useSelector(state => state.common.userDetails)

  const [token, setToken] = useState(modalDropdown[0].value)

  let [web3, setWeb3] = useState(null)
  let [isWalletConnected, setWalletConnected] = useState(false)
  let [connectedWallet, setConnectedWallet] = useState(null)

  const [tierQuantity, setTierQuantity] = useState({
    "tier-1": 0,
    "tier-2": 0,
    "tier-3": 0
  })

  const [currentTier, setCurrentTier] = useState("")

  const history = useHistory()
  const location = useLocation()
  const navigate = useNavigate()

  const user = localStorage.getItem("loginUser")
  const loginUserToken = localStorage.getItem("loginUserToken")
  const loginUserId = localStorage.getItem("loginUserId")
  const loginUserMail = localStorage.getItem("loginUserMail")

  const toggleModalView = () => {
    setViewModal(prevState => !prevState)
  }

  useEffect(() => {
    // checkIfWalletAlreadyConnected();
    setUserLogin(localStorage.getItem("loginUser"))
    if (
      !props.location.state?.selectedId &&
      props.location.state?.selectedNFM
    ) {
      setSingleProduct(props.location.state.selectedNFM)
    } else {
      axios
        .get(`${BaseUrl}/product/get/${props.location.state?.selectedId}`)
        .then(response => {
          if (response.status === 200) {
            setSingleProduct(response.data.data?.[0] ?? {})
            setCurrentTier(response.data.data?.[0]?.group_name ?? "")
            setTierQuantity(prevState => ({
              ...prevState,
              [response.data.data?.[0]?.group_name]: 1
            }))
          } else if (response.status == 401) {
            logoutHandler()
          } else if (response.status == 404) {
            swal({
              title: "Error!",
              text: "Page not found. Please try again later.",
              icon: "error"
            })
          } else if (response.status == 500) {
            swal({
              title: "Error!",
              text: "Something went wrong. Please try again later.",
              icon: "error"
            })
          } else if (response.status == 503) {
            swal({
              title: "Error!",
              text: "Something went wrong. Please try again later.",
              icon: "error"
            })
          } else {
            setSingleProduct({})
          }
        })
        .catch(error => {
          if (error?.response?.status === 401) {
            logoutHandler()
          } else {
            setSingleProduct({})
            console.log(error.message)
          }
        })
    }
  }, [location])

  const onSuccess = payment => {
    // Congratulations, the payment was successful!
  }

  const onCancel = data => {
    // User pressed 'cancel' or closed the PayPal popup window
  }

  let env = "sandbox" // you can set here to 'production' for production
  let currency = "USD" // or you can set this value from your props or state
  let total = 10 // same as above, this is the total amount (based on currency) to be
  let locale = "en_US"
  const client = {
    sandbox:
      "AXOuInfLyUn3p8-Dn5MFQlMaldituFtqiQOZ7oW_XVegDK10NN4Ahq_GMm6ZErYGaT7C4L42F6in9Y1J"
  }
  const closeProduct = () => {
    history.push("/")
  }
  const checkUserLogin = () => {
    userLogin
      ? continuePay()
      : navigate("/login", {
          productprops: { locationFrom: "productDetails" }
        })

    window.localStorage.setItem("locationFrom", "productDetails")
    window.localStorage.setItem("locationFromPId", location.state?.selectedId)
  }
  const closeLogin = () => {
    setOpenLogin(true)
    window.location.reload()
  }
  const continuePay = () => {
    const fObj = {
      user_id: loginUserId,
      payer_email: loginUserMail,
      amount: singleProduct?.price,
      product_id: singleProduct?.id
    }

    axios
      .post(`${BaseUrl}/createorder`, fObj, {
        headers: {
          Authorization: `Bearer ${loginUserToken}`
        }
      })
      .then(response => {
        if (response) {
          window.open(response.data.data.host_url, "_blank")
        } else {
        }
      })
      .catch(error => {
        if (error?.response?.status == 401) {
          logoutHandler()
        }
      })
  }

  const connectToWallet = async () => {
    console.log(
      `[nft][src][components][components][pages][pendingPayments][connectToWallet] connectToWallet`
    )
    if (typeof window.ethereum !== "undefined") {
      let accounts = await window.ethereum.request({
        method: "eth_requestAccounts"
      })
      window.web3 = new Web3(window.ethereum)
      setWeb3(window.web3)
      let chainId = await window.web3.eth.getChainId()
      if (chainId !== parseInt(constant.CHAIN_ID)) {
        // swal({
        //   title: "Invalid Network!",
        //   text: `Switch your network to ${constant.NETWORK_NAME}`,
        //   icon: "error",
        //   confirmButtonText: "Ok",
        // });
        return
      }
      cookies.set("wallet", accounts[0], { path: "/" })
      cookies.set("wallet_status", 1, { path: "/" })
      setWalletConnected(true)
      setConnectedWallet(accounts[0])
      setWeb3(window.web3)
    } else {
      cookies.set("wallet", null, { path: "/" })
      cookies.set("wallet_status", 0, { path: "/" })
      setWalletConnected(false)
      setConnectedWallet(null)
      setWeb3(null)
      swal({
        title: "Unsupported Browser",
        text: `Please use Google Chrome with Metamask Plugin Installed`,
        icon: "error",
        confirmButtonText: "Ok"
      })
      console.log("Unsupported Browser")
    }
  }

  const checkIfWalletAlreadyConnected = async () => {
    let walletStatus = cookies.get("wallet_status")
    let connectedWallet = cookies.get("wallet")
    if (parseInt(walletStatus) == 1) {
      console.log(
        `[nft][src][components][components][pages][checkIfWalletAlreadyConnected] walletStatus 1 ${walletStatus}`
      )
      if (connectedWallet !== null || connectedWallet !== undefined) {
        cookies.set("wallet", connectedWallet, { path: "/" })
        cookies.set("wallet_status", 1, { path: "/" })
        setWalletConnected(true)
        setConnectedWallet(connectedWallet)
        setWeb3(web3)
      }
    } else {
      console.log(
        `[nft][src][components][components][pages][checkIfWalletAlreadyConnected] walletStatus 2 ${walletStatus}`
      )
      cookies.set("wallet", null, { path: "/" })
      cookies.set("wallet_status", 0, { path: "/" })
      setWalletConnected(false)
      setConnectedWallet(null)
      setWeb3(null)
    }
  }

  const placeOrder = () => {
    let loginToken = userData?.loginUserToken
    let data = {
      tier: tierQuantity
    }
    var config = {
      method: "post",
      url: `${BaseUrl}/preorder`,
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    }
    axios(config)
      .then(response => {
        console.log("response", response)
        if (response.status == 200) {
          if (loginToken) {
            axios
              .get(`${BaseUrl}/addorder/${response.data.token}`, {
                headers: {
                  Authorization: `Bearer ${loginToken}`
                }
              })
              .then(response => {
                console.log(response, "new resp")
                if (response.status == 200) {
                  navigate("/myaccount/pendingpayments")
                  dispatch(setActiveMenu("NFM"))
                }
              })
          } else {
            localStorage.clear()
            localStorage.setItem("buyNitroToken", response.data.token)
            navigate("/login")
          }
        } else if (response.status == 401) {
          logoutHandler()
        } else if (response.status == 404) {
          swal({
            title: "Error!",
            text: "Page not found. Please try again later.",
            icon: "error"
          })
        } else if (response.status == 500) {
          swal({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error"
          })
        } else if (response.status == 503) {
          swal({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error"
          })
        } else {
          console.log("response")

          swal({
            title: "Failed",
            text: "Something went wrong.",
            icon: "error"
          })
        }
      })
      .catch(error => {
        if (error?.response?.status == 401) {
          logoutHandler()
        } else
          swal({
            title: "Failed",
            text: "Something went wrong.",
            icon: "error"
          })
      })
  }

  console.log(currentTier, "currentTier")
  return (
    <div>
      <div
        className="container product-detail-marketplace-space"
        id="product-detail-container">
        <div
          className="go-back-btn"
          style={{
            alignSelf: "flex-start",
            fontSize: "1.1rem",
            cursor: "pointer"
          }}
          onClick={() => history.goBack()}>
          <span
            id="pay-now-btn"
            className="text-white"
            style={{
              fontSize: "1rem",
              borderRadius: "50%",
              padding: "12px 15px"
            }}>
            &#129044;
          </span>
          <span className="text-white text-bold"> Go Back</span>
        </div>
        <section id="nitro-nft-miner">
          <ModalMint
            showModal={viewModal}
            toggleModalView={toggleModalView}
            balance={singleProduct?.price}
            tier={singleProduct?.group_name}
          />
          <div
            className="nitro-hero-section pending-one center-aligned-details"
            id="product-details">
            {singleProduct !== null && Object.keys(singleProduct).length ? (
              <>
                <div
                  className="nitro-img"
                  style={{
                    height: "auto",
                    overflow: "auto",
                    maxHeight: "none"
                  }}>
                  <img
                    style={{ height: "auto" }}
                    src={singleProduct?.product_image}
                    alt={singleProduct?.mystery}
                  />
                </div>

                <div className="nitro-text small-width" id="text-detail">
                  <h1 className="pink-text">{singleProduct?.mystery}</h1>
                  <div className="line"></div>

                  <p>{singleProduct?.product_desc}</p>

                  <div className=" justify-content-between flex-wrap max-width-40em">
                    <p className="purple-text">
                      Category :{" "}
                      <span className="text-white">
                        {singleProduct?.category_name}
                      </span>
                    </p>
                    <p className="purple-text">
                      Group Name :{" "}
                      <span className="text-white">
                        {capitalize(singleProduct?.group_name)}
                      </span>
                    </p>
                  </div>
                  <div className=" justify-content-between align-items-center flex-wrap max-width-40em">
                    <p className="purple-text">
                      Purchased price :{" "}
                      <span className="text-white text-bold">
                        ${singleProduct?.price}
                      </span>
                    </p>

                    {props.location.state.selectedId &&
                    !props.location.state?.selectedNFM ? (
                      <div className="d-flex align-items-center justify-content-around">
                        <div className="counter">
                          <p
                            className="minus"
                            onClick={
                              tierQuantity[currentTier]
                                ? () => {
                                    setTierQuantity(prevState => ({
                                      ...prevState,
                                      [currentTier]: prevState[currentTier] - 1
                                    }))
                                  }
                                : () => {}
                            }>
                            <i className="fa fa-minus"></i>
                          </p>
                          <input
                            type="number"
                            name="update"
                            id="number-update"
                            min="11"
                            value={tierQuantity[currentTier]}
                            onChange={() => {}}
                          />
                          <p
                            className="plus"
                            onClick={() => {
                              setTierQuantity(prevState => ({
                                ...prevState,
                                [currentTier]: prevState[currentTier] + 1
                              }))
                            }}>
                            <i className="fa fa-plus"></i>
                          </p>
                        </div>
                        <p className="purple-text">
                          <button
                            onClick={
                              tierQuantity[currentTier] &&
                              currentTier !== "tier-1"
                                ? placeOrder
                                : () => {}
                            }
                            id="pay-now-btn"
                            style={
                              currentTier === "tier-1" ||
                              !tierQuantity[currentTier]
                                ? {
                                    filter: "brightness(0.65)"
                                  }
                                : null
                            }>
                            Buy NFM
                          </button>
                        </p>
                      </div>
                    ) : null}
                  </div>
                </div>
              </>
            ) : (
              <div className="nitro-text small-width">
                <h1 className="pink-text">
                  {singleProduct === null
                    ? "Loading..."
                    : "Product not found. Please retry"}
                </h1>
                <div className="line"></div>
              </div>
            )}
          </div>
        </section>
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default ProductDetails
